module.exports = __webpack_public_path__ + "img/GAME_THREE.6f1e3b8d.jpg";